<svg xmlns="http://www.w3.org/2000/svg" width="6" height="5" viewBox="0 0 6 5">
  <path d="M3,0,6,5H0Z" transform="translate(6 5) rotate(180)" fill="#5d678b" />
</svg>
